import Swiper from 'swiper/bundle'
import { Navigation, EffectFade, Autoplay } from 'swiper/modules'

export default class Testimonials {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      modules: [Navigation, EffectFade, Autoplay],
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoHeight: true,
      speed: 500,
      autoplay: { delay: 3500, disableOnInteraction: false },
      navigation: {
        prevEl: this.el.querySelector('.testimonials--prev'),
        nextEl: this.el.querySelector('.testimonials--next'),
      },
    })
  }
}
